export default __webpack_public_path__ + "static/media/featured.db819d11.png";